import React, { useEffect, useState } from "react";
import styles from "./largeCapStrategy.module.css";
import { getLearnMoreLargeCap } from "../../services/request/learnMore";
import renameObjectKey from "../../utils/renameObjectKey";
import Mail from "../../commomComponents/mail";
import LearnMoreBanner from "./commonComponents/LearnMoreBanner";
import LearnMoreMainText from "./commonComponents/LearnMoreMainText";
import LearnMoreSectionOne from "./commonComponents/LearnMoreSectionOne";
import LearnMoreSectionTwo from "./commonComponents/LearnMoreSectionTwo";
import LearnMoreSectionThree from "./commonComponents/LearnMoreSectionThree";
import DisclaimerText from "./commonComponents/DisclaimerText";
import Loader from "../../commomComponents/Loader";
import SeoHelmet from "../../commomComponents/seoHelmet";
let footerTextsKeyAttribute =
  "*The key attributes mentioned above are only indicative. There may be other criteria also which can be considered for the selection of large cap companies under the Strategy";
let footerTextsProcessInvestment =
  "Please note that BMV framework mentioned above is developed in house and only indicative in nature. The strategies offered by the Portfolio Manager may or may not follow the above framework at all times. The framework is developed in order to select the right companies through a filtration process and endeavor the strategy to attain their investment objective. These models are based on various broad market parameters prevalent in the market and are dynamic in nature.";

export default function LargeCapStrategy(props) {
  const [res, setRes] = useState(null);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    document.title = "Large Cap Mutual Funds: Expert Large Cap Investment Strategy | ICICI Pru Alternates";
    setLoader(true);
    let response = getLearnMoreLargeCap();
    response.then((resData) => {
      console.log("first", resData);
      setRes(resData.data.res[0]);
      setLoader(false);
    });
  }, []);

  return (
    <>
      <SeoHelmet
        title="Large Cap Mutual Funds: Expert Large Cap Investment Strategy | ICICI Pru Alternates"
        description="Discover the best large cap equity funds and investment strategies. ICICI Prudential PMS Large Cap Portfolio offers superior financial growth and security."
        url="https://www.iciciprualternates.com/portfolio-management-service/largecap-strategy"
      />
      <div className={styles.largeCapStrategy}>
        {loader ? (
          <Loader />
        ) : res ? (
          <>
            <Mail />
            <LearnMoreBanner
              image={res.bannerImage}
              title={res.bannerTitle}
              subTitle={res.bannerSubTitle}
              presentation={res.presentation}
              factSheet={res.factsheet}
            />
            <LearnMoreMainText text={res.mainText} />
            <LearnMoreSectionOne
              title={res.sectionOneTitle}
              data={res.sectionOneContent}
            />
            <LearnMoreSectionTwo
              title={res.sectionTwoTitle}
              data={res.sectionTwoContent}
              disclaimer={footerTextsProcessInvestment}
            />
            <LearnMoreSectionThree
              title={res.sectionThreeTitle}
              data={res.sectionThreeContent}
            />

            <DisclaimerText text={res.disclaimer} />
          </>
        ) : null}
      </div>
    </>
  );
}
